import { apiFetch } from './client';

export const listOrderOfService = (token) => apiFetch(token, '/order-of-service');

export const createOrderOfService = (token, formData) =>
  apiFetch(token, '/order-of-service', { method: 'POST', body: formData });

export const deleteOrderOfService = (token, orderOfServiceId) =>
  apiFetch(token, `/order-of-service/${orderOfServiceId}`, { method: 'DELETE' });
